module.exports = __webpack_public_path__ + "img/user.d5354fb8.webp";